import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import WhoWeAre from "@/components/site/WhoWeAre";
import Stats from "@/components/site/Stats";
import Services from "@/components/site/Services";
import Focus from "@/components/site/Focus";
import Philosophy from "@/components/site/Philosophy";
import AboutMarkets from "@/components/site/AboutMarkets";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="App bg-[#0A1224] font-sans text-white antialiased">
            <Nav />
            <main>
                <Hero />
                <Marquee />
                <WhoWeAre />
                <Stats />
                <Services />
                <Focus />
                <Philosophy />
                <AboutMarkets />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}

export default App;
